/**
 * region for helpers*/
import decode from 'jwt-decode';

/**
 * region for helpers*/
import Constants from '../constants/Constants';

export default class AuthService {

    // Initializing important variables
    constructor(domain) {
        this.domain = domain
        this.loggedIn = this.loggedIn.bind(this)
        this.fetch = this.fetch.bind(this)
        this.login = this.login.bind(this)
        this.tokenValid = true;
    }

    login(token, callback) {
        this.fetch(Constants.ROUTE_USER_LOGIN + "?token=" + token, {
            method: 'POST'
        }).then(res => {
            this.setToken(res.token) // Setting the token in sessionStorage and localStorage
            callback();
            //Promise.resolve(res);
        })

    }

    loggedIn() {
        // Checks if there is a saved token and it's still valid
        const token = this.getToken() // GEtting token from sessionStorage or localstorage
        return !!token && !this.isTokenExpired(token) // handwaiving here
    }
    
    isTokenExpired(token) {
        try {
            const decoded = decode(token);
            if (decoded.exp < Date.now() / 1000) { // Checking if token is expired. N
                window.sessionStorage.clear();
                localStorage.clear();
                return true;
            }
            else {
                return false;
            }   
        }
        catch (err) {
            window.sessionStorage.clear();
            localStorage.clear();
            return true;
        }
    }

    getToken() {
        // Retrieves the user token from sessionStorage
        const sessionStorage = window.sessionStorage.getItem('id_token');
        if (sessionStorage)
            return sessionStorage;
        // Retrieves the user token from localStorage
        return localStorage.getItem('id_token');
    }

    setToken(idToken) {
        // Saves user token to sessionStorage
        window.sessionStorage.setItem('id_token', idToken);
        // Saves user token to localStorage
        localStorage.setItem('id_token', idToken);
    }

    fetch(url, options) {
        // performs api calls sending the required authentication headers
        const headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }

        // Setting Authorization header
        // Authorization: Bearer xxxxxxx.xxxxxxxx.xxxxxx
        if (this.loggedIn()) {
            headers['Authorization'] = 'Bearer ' + this.getToken()
        }

        return fetch(url, {
            headers,
            ...options
        })
            .then(this._checkStatus)
            .then(response => response.json())
    }

    _checkStatus(response) {
        // raises an error in case response status is not a success
        if (response.status >= 200 && response.status < 300) { // Success status lies between 200 to 300
            return response
        } else {
            window.sessionStorage.clear();
            localStorage.clear();
            var error = new Error(response.statusText)
            error.response = response
            throw error
        }
    }
}
